import React from "react";
import { NavWrap } from "./ShopForTyres";
import download from "../assets/download.svg";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { get_marketings } from "../actions/auth/Action";

export const zones = {
  Z1: "Radar USA",
  Z2: "Radar APAC/MEAI",
  Z3: "Radar APAC/MEAI",
  Z4: "Radar Canada",
  Z5: "Radar Europe",
  Z6: "OmniSource USA",
};
const Marketing = () => {
  const dispatch = useDispatch();
  const marketings = useSelector(
    (state) => state?.marketings?.data?.marketings ?? []
  );
  useEffect(() => {
    dispatch(
      get_marketings({
        kdgrp: localStorage.getItem("kdgrp"),
      })
    );
    // eslint-disable-next-line
  }, []);

  const zone_materials = {
    z1: [
      { label: "Logo", value: "logo" },
      { label: "Brand Manual", value: "brand_manual" },
      { label: "Catalog", value: "catalouges" },
      { label: "POS Guideline", value: "pos_material" },
    ],
    z6: [
      { label: "Logo", value: "logo" },
      { label: "Brand Manual", value: "brand_manual" },
      { label: "Catalog", value: "catalouges" },
      { label: "POS Guideline", value: "pos_material" },
    ],
    z4: [
      { label: "Logo", value: "logo" },
      { label: "Brand Manual", value: "brand_manual" },
      { label: "Catalog", value: "catalouges" },
      { label: "POS Guideline", value: "pos_material" },
    ],
    z5: [
      { label: "Logo", value: "logo" },
      { label: "Brand Manual", value: "brand_manual" },
      { label: "Catalog", value: "catalouges" },
      { label: "POS Guideline", value: "pos_material" },
    ],
    z3: [
      { label: "Logo", value: "logo" },
      { label: "Brand Manual", value: "brand_manual" },
      { label: "Catalog", value: "catalouges" },
      { label: "POS Guideline", value: "pos_material" },
    ],
    z2: [
      { label: "Logo", value: "logo" },
      { label: "Brand Manual", value: "brand_manual" },
      { label: "Catalog", value: "catalouges" },
      { label: "POS Guideline", value: "pos_material" },
    ],
  };

  return (
    <NavWrap>
      <div className="marketing">
        <button
          onClick={() => {
            window.open("https://omnisourceusa.com/omnisync.html", "_blank");
          }}
          className="primary-btn"
          style={{
            position: "absolute",
            right: "5rem",
          }}
        >
          Link To Video Tutorial
        </button>
        <h3>{zones[localStorage.getItem("kdgrp")] ?? ""}</h3>
        {zone_materials[localStorage.getItem("kdgrp")?.toLowerCase()]?.map(
          (item) => (
            <>
              <ul className="download-items">
                <h2>{item.label}</h2>
                {marketings?.length
                  ? marketings
                      ?.filter((ele) => ele.category === item.value)
                      ?.map((ele) => (
                        <li>
                          <img
                            src={download}
                            alt="download"
                            width={20}
                            height={12}
                          />
                          <strong>
                            <span
                              onClick={() => {
                                window.open(ele.file, "_blank");
                              }}
                            >
                              {ele.file_name}
                            </span>
                          </strong>
                        </li>
                      ))
                  : "No Documents Found"}
              </ul>
              <br />
            </>
          )
        )}
      </div>
    </NavWrap>
  );
};

export default Marketing;
